const mediaItems = [
  {
    title: '《暗潮》 — 年度悬疑巨制预告',
    desc: '错综复杂的案件背后，真相与谎言交织。金牌导演李明远最新力作，引爆全网期待。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20film%20atmosphere%2C%20rainy%20city%20alley%20at%20night%20with%20warm%20street%20lamp%20glow%2C%20cinematic%20lighting%2C%20noir%20aesthetic%2C%20suspenseful%20mood%2C%20film%20grain%20texture%2C%20no%20text&width=640&height=360&seq=media-chunse-01&orientation=landscape',
    tag: '悬疑',
    views: '128万',
  },
  {
    title: '《山河纪》第三季 — 史诗回归',
    desc: '波澜壮阔的历史画卷再度展开，原班人马倾情演绎家国情怀。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20historical%20drama%20scene%20with%20ancient%20Chinese%20landscape%2C%20misty%20mountains%2C%20warm%20sunset%20tones%2C%20traditional%20architecture%2C%20cinematic%20composition%2C%20grand%20scale%2C%20no%20text&width=640&height=360&seq=media-chunse-02&orientation=landscape',
    tag: '古装',
    views: '256万',
  },
  {
    title: '《星际迷航：新纪元》 — 科幻冒险',
    desc: '探索未知星系，人类命运的终极考验。视觉特效全面升级，IMAX级观影体验。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20space%20scene%20with%20distant%20galaxy%2C%20spaceship%20silhouette%2C%20deep%20cosmic%20background%2C%20warm%20nebula%20colors%2C%20cinematic%20wide%20shot%2C%20atmospheric%2C%20no%20text&width=640&height=360&seq=media-chunse-03&orientation=landscape',
    tag: '科幻',
    views: '189万',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            精选预告
          </h2>
          <p className="text-sm text-foreground-400">即将上线热门内容抢先看</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-200/40 rounded-lg border border-background-300/20 overflow-hidden cursor-pointer hover:border-primary-500/30 transition-colors"
            >
              <div className="relative aspect-video bg-background-300/30 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-950/70 text-xs text-primary-400 font-medium backdrop-blur-sm">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90">
                    <i className="ri-play-fill text-background-50 text-2xl ml-1"></i>
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 text-xs text-foreground-300">
                  <i className="ri-eye-line mr-1"></i>{item.views}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100 group-hover:text-primary-400 transition-colors mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}